import { cn } from "@/lib/utils";
import styles from "./InfoCard.module.css";

function renderIcon(icon, medal) {
  return (
    <div className="flex">
      {medal ? (
        icon
      ) : (
        <div
          className={`flex justify-center items-center p-4 text-lg rounded-full md:p-5 md:ml-1 md:text-2xl bg-altgray-50 text-altgray-700`}
        >
          {icon}
        </div>
      )}
    </div>
  );
}

export default function InfoCard({
  title = null,
  icon = null,
  children = null,
  medal = false,
}) {
  return (
    <div
      className={`relative flex w-full md:rounded-t-xl h-24 md:h-32 text-white
      pl-5 md:pl-6 group ${styles.header} bg-[linear-gradient(to_left,rgba(0,0,0,0)_0%,rgba(0,0,0,1.8)_100%)]`}
    >
      <div className="flex items-center space-x-3 w-full md:space-x-4">
        {icon && renderIcon(icon, medal)}
        <div
          className={cn(
            "flex flex-col w-full",
            medal ? "space-y-3 md:space-y-3" : "space-y-2 md:space-y-3"
          )}
        >
          <div className="flex items-center space-x-1 w-full text-xl font-semibold capitalize rounded-t-xl border-altgray-100">
            {title}
          </div>
          {children}
        </div>
      </div>
    </div>
  );
}
